import { generateUtilityClasses } from '@mui/material';

export const iconButtonClasses = generateUtilityClasses('IconButton', ['root']);

export type IconButtonClasses = typeof iconButtonClasses;
